import { Flex } from 'antd';
import Accordion from 'components/Accordion';
import TaskInfo from 'components/TaskInfo';
import { useMemo } from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { renderDate, renderInfoValue, renderLocation } from 'utils/helpers';

import { ArrowRightOutlined } from '@ant-design/icons';
import StatusTag from 'components/StatusTag';
import { Link } from 'react-router-dom';
import { routes } from 'routes/AllRoutes';
import { getPipePictureList } from 'screens/PipeReview/helper';
import { Pipe } from 'types/common';
import { SelectTaskData } from '../../../../sales-group-progress';
import './style.scss';

const PIPE_INSTALLATION = 'PIPE_INSTALLATION';

type TestProps = {
  data: SelectTaskData;
  pipeData: Pipe;
  index: number;
};

function PipeInstallationAccordion({ data, pipeData, index }: TestProps) {
  const { location, createdAt, farmerDto, documentList, taskLog } = {
    ...pipeData,
  };

  const imagesArray = documentList?.filter(
    (image) => image.tag === PIPE_INSTALLATION,
  );

  const { rejectedPictures } = getPipePictureList(pipeData, imagesArray);

  const HeaderContent = useMemo(
    () => (
      <Flex justify="space-between" align="baseline">
        <StatusTag status={pipeData?.installationImageReviewStatus} />
        <div className="accordion-content">{`Installed on ${renderDate(createdAt)}`}</div>
      </Flex>
    ),
    [createdAt],
  );

  return (
    <Accordion
      title={`Pipe ${index + 1}`}
      className="pipe-accordion"
      headerContent={HeaderContent}
    >
      <Flex vertical gap={10}>
        <TaskInfo
          header="GPS"
          valueClass="pipe-details-field-value"
          renderValue={() => renderLocation(location)}
        />

        <TaskInfo
          header="Farmers Associated"
          valueClass="pipe-details-field-value"
          renderValue={() => renderInfoValue(farmerDto[0]?.name, 'N/A')}
        />

        <TaskInfo
          header="Photos"
          valueClass="pipe-details-field-value mt-1"
          renderValue={() =>
            imagesArray.length === 0 ? (
              <TaskInfo
                wrapperClass="p-0"
                labelClass="d-none"
                valueClass="pipe-details-field-value"
                value="No photos available"
              />
            ) : (
              <Flex vertical gap={8}>
                <div>
                  <PhotoProvider>
                    {imagesArray?.map((image, index) => (
                      <PhotoView src={image?.url} key={`pipe-img-${index}`}>
                        <img
                          src={image?.url}
                          alt="Pipe Installation 1"
                          className="pipe-img"
                          style={{
                            height: '128px',
                            paddingRight: '10px',
                            paddingBottom: '10px',
                          }}
                        />
                      </PhotoView>
                    ))}
                  </PhotoProvider>
                </div>
              </Flex>
            )
          }
        />

        <TaskInfo
          header="Rejected Photos"
          valueClass="pipe-details-field-value mt-1"
          renderValue={() =>
            rejectedPictures?.length === 0 ? (
              <TaskInfo
                wrapperClass="p-0"
                labelClass="d-none"
                valueClass="pipe-details-field-value"
                value="No photos available"
              />
            ) : (
              <Flex vertical gap={8}>
                <div>
                  <PhotoProvider>
                    {rejectedPictures?.map((image, index) => (
                      <PhotoView src={image.url} key={`rejected-img-${index}`}>
                        <img
                          src={image.url}
                          alt="Rejected Pipe Installation"
                          className="pipe-img"
                          style={{ height: '128px', paddingRight: '10px' }}
                        />
                      </PhotoView>
                    ))}
                  </PhotoProvider>
                </div>
                <Link
                  to={{
                    pathname: routes.pipeReview,
                    search: `seasonId=${data?.season?.id}&documentId=${imagesArray?.[0]?.id}`,
                  }}
                  className="link-text"
                >
                  Review Pipe Pictures <ArrowRightOutlined />
                </Link>
              </Flex>
            )
          }
        />

        <TaskInfo
          header="Notes"
          valueClass="pipe-details-field-value"
          renderValue={() => renderInfoValue(taskLog?.notes, 'N/A')}
        />
      </Flex>
    </Accordion>
  );
}

export default PipeInstallationAccordion;
